type SnapshotLike = {
  isComplete?: boolean;
  blockedReasons?: string[];
  capture?: Record<string, unknown>;
  ocr?: Record<string, unknown>;
  signals?: Record<string, unknown>;
  ai?: Record<string, unknown>;
  locate_crop?: Record<string, unknown>;
} | null;

type DiagnosticLike = Record<string, unknown> | null | undefined;

const TERMINAL_STATUSES = new Set(["COMPLETE", "COMPLETE_WITH_ERRORS", "PARTIAL", "FAILED", "CANCELLED", "SKIPPED"]);

function extractSnapshot(diagnostics: DiagnosticLike): SnapshotLike {
  if (!diagnostics || typeof diagnostics !== "object") return null;
  const snapshot = (diagnostics as Record<string, unknown>).s1_state_snapshot;
  if (!snapshot || typeof snapshot !== "object") return null;
  return snapshot as SnapshotLike;
}

function isTerminalStatus(status: string | null | undefined): boolean {
  if (!status) return false;
  return TERMINAL_STATUSES.has(String(status).toUpperCase());
}

export function selectCanonicalS1Snapshot(input: {
  s14Status: string | null | undefined;
  s14Diagnostics: DiagnosticLike;
  aiDiagnostics: DiagnosticLike;
  signalsDiagnostics: DiagnosticLike;
  ocrDiagnostics: DiagnosticLike;
}): { snapshot: SnapshotLike; source: "S1_4" | "S1_AI" | "S1_SIGNALS" | "S1_OCR" | "NONE" } {
  const s14Snapshot = extractSnapshot(input.s14Diagnostics);
  if (s14Snapshot) {
    return { snapshot: s14Snapshot, source: "S1_4" };
  }

  // If locate/crop has already reached a terminal attempt but does not carry a
  // canonical snapshot payload yet, do not trust stale upstream snapshots.
  // The caller should recompute fallback canonical truth from current attempts.
  if (isTerminalStatus(input.s14Status)) {
    return { snapshot: null, source: "NONE" };
  }

  const aiSnapshot = extractSnapshot(input.aiDiagnostics);
  if (aiSnapshot) return { snapshot: aiSnapshot, source: "S1_AI" };

  const signalsSnapshot = extractSnapshot(input.signalsDiagnostics);
  if (signalsSnapshot) return { snapshot: signalsSnapshot, source: "S1_SIGNALS" };

  const ocrSnapshot = extractSnapshot(input.ocrDiagnostics);
  if (ocrSnapshot) return { snapshot: ocrSnapshot, source: "S1_OCR" };

  return { snapshot: null, source: "NONE" };
}
